function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-facebook-square-gradient_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: 20,
  x2: 20,
  y2: 40
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c31446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#891731"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40 8v24a8 8 0 01-8 8h-5.78V24.89h6.67v-6.67h-6.67v-2.65c0-1.08.69-1.79 1.28-1.79h5.39V7.11H27.5c-4.14 0-7.5 4-7.5 8.51v2.6h-4.89v6.67H20V40H8a8 8 0 01-8-8V8a8 8 0 018-8h24a8 8 0 018 8z",
  fill: "url(#icon-facebook-square-gradient_svg__a)"
});

function SvgIconFacebookSquareGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxsaW5lYXJHcmFkaWVudCBpZD0iaWNvbi1mYWNlYm9vay1hIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjIwIiB4Mj0iMjAiIHkyPSI0MCI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjYzMxNDQ2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODkxNzMxIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJtNDAgOHYyNGE4IDggMCAwIDEgLTggOGgtNS43OHYtMTUuMTFoNi42N3YtNi42N2gtNi42N3YtMi42NWMwLTEuMDguNjktMS43OSAxLjI4LTEuNzloNS4zOXYtNi42N2gtNS4zOWMtNC4xNCAwLTcuNSA0LTcuNSA4LjUxdjIuNmgtNC44OXY2LjY3aDQuODl2MTUuMTFoLTEyYTggOCAwIDAgMSAtOC04di0yNGE4IDggMCAwIDEgOC04aDI0YTggOCAwIDAgMSA4IDh6IiBmaWxsPSJ1cmwoI2ljb24tZmFjZWJvb2stYSkiLz48L3N2Zz4K";
export { SvgIconFacebookSquareGradient as ReactComponent };